var exports = {
  "kL": "SidebarShellSkeleton.module__container___LUFQTm",
  "Kd": "SidebarShellSkeleton.module__containerMobile___LUFQTm",
  "DF": "SidebarShellSkeleton.module__headerFrame___LUFQTm",
  "VH": "SidebarShellSkeleton.module__headerFrameBanner___LUFQTm",
  "kW": "SidebarShellSkeleton.module__headerBanner___LUFQTm",
  "wx": "SidebarShellSkeleton.module__header___LUFQTm",
  "D": "SidebarShellSkeleton.module__headerCaret___LUFQTm",
  "Qs": "SidebarShellSkeleton.module__content___LUFQTm",
};

module.exports = exports;
